/**
 * Normalize a floating number, always floors to two decimals
 */
const normalizeReturns = (winAmount: number) => {
	// Round using exponential notation to avoid binary floating-point approximation
	return +`${Math.floor(Number(`${winAmount}e+2`))}e-2`;
};

export default normalizeReturns;
